import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  styled,
  Tab,
} from "@mui/material";
import BsModal from "../BaseModal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasAuthority } from "../../../../utils/authorities";
import { dateFormater } from "../../../utils/common/utils";
import { Tooltip } from "@mui/material";
import { RenderTooltipContent } from "./renderTooltip";
import { HistoryIcon, FreshIcon, Cryopreserve, PoolIcon } from "../../../assets/CommonSvg";
import HistoryDrawer from "./historyDrawer";
import { selectVienToVienLoading } from "../../../slices/logisticSlice";
import { selectManufactureProductLoading } from "../../../slices/manufacturer";
import { changeV2VCycle, selectActiveV2VCycle, selectCurrentCycle, selectV2VCycle } from "../../../slices/common";
import RestartManufacturingForm from "./RestartManufacturingForm";
import StartManufacturingForm from "./StartManufacturingForm";
import ReferenceSection from "../Information/ReferenceSection"
import InfusionDateForm from "./InfusionForm";
import MarkAsCompleteForm from './MarkAsCompleteForm'
import {truncateText} from "../../../../utils/utils"
import { useSearchParams } from 'react-router-dom';
import CryoLsmFormDialog from "../../features/ManufacturingForm/Common/CryoLsmFormDialog";
import BatchReleaseCertificate from "../../../pages/Manufacturer/print/BatchReleaseCertificate"
const StepStatus = {
  0: "Pending",
  1: "In-progress",
  2: "Completed",
  3: "Rejected",
  4: "Submitted ",
  5: "Submitted for review",
  6: "LSM cryopreserved"
};

const StepStatusColor = {
  0: "text-gray-600",
  1: "text-yellow-500",
  2: "text-green-600",
  3: "text-red-600",
  4: "text-yellow-500",
  5: "text-yellow-600",
  6: "text-yellow-500",
};
const CycleStatusColor = {
  0: "text-red-600",
  1: "text-green-600",
  2: "text-red-600",
};
const CycleStatus = {
  0: "In-Active",
  1: "Active",
  2: "Terminate",
};
const BarConnector = styled(StepConnector)(() => ({
  "& .MuiStepConnector-line": {
    height: 3,
    borderRadius: 2,
    border: "none",
    backgroundColor: "#CFD6DC",
    marginLeft: "-50%",
    marginRight: "55%",
    marginTop: "-3px",
  },
}));

const StepIconWrapper = styled("div")(({ completed }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "50%",
  backgroundColor: completed ? "transparent" : "#CFD6DC",
  border: completed ? "1px solid #3571FF" : "none",
}));

const InnerCircle = styled("div")(({ completed }) => ({
  width: 12,
  height: 12,
  borderRadius: "50%",
  backgroundColor: completed ? "#3571FF" : "transparent",
}));

const maintainSteps = (initialSteps = [], permissionsList, authorizedPerson, buttonPop,role_slug,currentCycle) => {
  const res = [];
  for (let ind in initialSteps) {
    let step = { ...initialSteps[ind] };
    step.actions = [];

    // ==============================
    // 🧩 Normal conditions (for steps not completed)
    // ==============================
    if (step.status != 2) {
      if (
        step.slug == "lsm-shipped" &&
        initialSteps[ind - 1]?.status === 2 &&
        hasAuthority(["in-bound-marked-shipped"], permissionsList) && buttonPop?.includes('lsm-shipped')
      ) {
        step.actions.push({ type: "dialog", title: "Mark as Shipped" });
      }

      if (
        step.slug == "lsm-received-cdm" &&
        initialSteps[ind - 1]?.status == 2 &&
        authorizedPerson
      ) {
        step.actions.push({ type: "action", title: "Mark as Received" });
      }

      if (
        step.slug == "apheresis" &&
        initialSteps[ind - 1]?.status == 2 &&
        authorizedPerson &&
        step.status == 0
      ) {
        step.actions.push({
          type: "action",
          color: "success",
          title: "Start Apheresis",
        });
      }

      if (
        step.slug == "lsm-dispatched" &&
        initialSteps[ind - 1]?.status == 2 &&
        authorizedPerson
      ) {
        step.actions.push({ type: "dialog", title: "Mark as Dispatched" });
      }

      if (
        step.slug == "lsm-received-bmr" &&
        initialSteps[ind - 1].status === 2 &&
        hasAuthority(["in-bound-marked-received"], permissionsList) && buttonPop?.includes('lsm-received-bmr')
      ) {
        step.actions.push({
          type: "action",
          color: "success",
          title: "Mark as Received",
        });
      }

      if (
        step.slug == "product-manufactured" &&
        initialSteps[+ind + 1].status == 0 &&
        initialSteps[ind - 1].status == 2
        && buttonPop?.includes('product-manufactured')
        && (step.status === 0)
      ) {
        if (
          hasAuthority(
            ["failed-manufacturing", "start-manufacturing"],
            permissionsList
          )
        ) {
          step.actions.push({ type: "dialog", title: "LSM Approval" });
        }
      }

      if (
        step.slug == "product-shipped" &&
        initialSteps[ind].status == 1 &&
        hasAuthority(["mark-as-product-shipped"], permissionsList)
      ) {
        step.actions.push({ type: "dialog", title: "Mark as Shipped" });
      }

      if (
        step.slug == "product-received" &&
        initialSteps[ind - 1].status === 2 &&
        authorizedPerson
      ) {
        step.actions.push({ type: "action", title: "Mark as Received" });
      }

      if (
        step.slug == "infusion" &&
        initialSteps[ind].status === 4 &&
       authorizedPerson
      ) {
        step.actions.push({
          type: "action",
          color: "success",
          title: "Complete Infusion",
        });
      }

    if(authorizedPerson && step.slug == "infusion" && buttonPop?.includes('add_infusion_date') && step.status == '0' && step?.is_publish == 1 && !step?.infusion_date){
      step.actions.push({ type: "dialog", title: "Infusion Date",  infusion: true });
  }

    }
    // ==============================
    // ⚙️ Product Manufactured Logic (always runs)
    // ==============================
    if (
      step.slug == "product-manufactured" &&
      initialSteps[ind - 1]?.status === 2
    ) {
      StepStatus[3] = "Failed";

      // Start or mark failed/completed
      if (
        (initialSteps[ind].status === 6 || initialSteps[ind].status === 8) &&
        hasAuthority(["start-manufacturing"], permissionsList) && buttonPop?.includes('start-manufacturing')
      ) {
        step.actions.push({ type: "dialog", start:true, title: "Start Manufacturing" });
      if ((initialSteps[ind].status === 8) &&
        hasAuthority(["start-manufacturing"], permissionsList) && buttonPop?.includes('start-manufacturing')
      ){
          step.actions.push({ type: "dialog", cryo:true, title: "Cryopreserve LSM",color: "warning", });
      }
      } else if (initialSteps[ind].status == 4) {
        if (hasAuthority(["completed-manufacturing"], permissionsList) && buttonPop?.includes('start-manufacturing') && currentCycle?.status != 2 && currentCycle?.status != 0) {
          step.actions.push({
            type: "dialog",
            color: "success",
            marks:true,
            title: "Mark as Completed",
          });
        }
        /*if (hasAuthority(["failed-manufacturing"], permissionsList) && buttonPop?.includes('start-manufacturing')) {
          step.actions.push({
            type: "dialog",
            color: "error",
            title: "Mark as Failed",
          });
        }*/
      }
      // Re-manufacturing and Re-generate logic for the same step
      if (initialSteps[ind].status >= 1 && initialSteps[ind].status !== 8) {
        if (
          initialSteps[ind].re_manufacture_status != 0 &&
          hasAuthority(["start-manufacturing"], permissionsList)
          && buttonPop?.includes('start-manufacturing') && step.status !== 6 && currentCycle?.status != 2 && currentCycle?.status != 0
        ) {
          step.actions.push({
            type: "dialog",
            extra: true,
            title: "Re-Manufacturing",
          });
            step.actions.push({ type: "dialog", finishProduct:true, title: "Print" });
        }
      }

      // ✅ NEW: If Under Quality Control step failed, show both buttons here too
      const nextStep = initialSteps[parseInt(ind) + 1];
      const nextToNext = initialSteps[parseInt(ind) + 2]
      if (((nextStep?.slug === "qc-testing" &&
        nextStep?.status == 3) || (nextToNext?.slug === "qa-review" &&
        nextToNext?.status == 3))
        && initialSteps[parseInt(ind) - 1]?.status == 2
        && buttonPop?.includes('start-manufacturing')
      ) {
        if (hasAuthority(["start-manufacturing"], permissionsList) && initialSteps[parseInt(ind) - 1].re_manufacture_status != 0) {
          step.actions.push({
            type: "dialog",
            extra: true,
            title: "Re-Manufacturing",
          });
            step.actions.push({ type: "dialog", finishProduct:true, title: "Print" });
        }
      }
    }

    if (
      step.slug == "qc-testing" && hasAuthority(["product-published"], permissionsList) &&
      step.status === 2 && initialSteps[ind - 1].status === 2 && initialSteps[ind].status !== 3 && step.product_completed_date == null
    ) {
      step.actions.push({ type: "action", title: "Publish" });
    }
    if(step.slug == "qa-review" && initialSteps[ind - 1].product_completed_date != null && ["quality-associate"]?.includes(role_slug))
       step.actions.push({ type: "dialog", print:true, title: "Batch Release Print" });
    res.push(step);
  }

  return res;
};



const ProgressTracker = ({
  steps,
  onAction,
  FormComponent = null,
  onUpdate,
  id = null,
  patient_id = null,
  formProps = undefined,
  buttonPop=[],
  onDirectPrint = null
}) => {
  const [searchParams] = useSearchParams();
  const batchU = searchParams.get('batch');
  const activeV2VCycle = useSelector(selectActiveV2VCycle) || 0;
  const V2VCycle = useSelector(selectV2VCycle);
  const vienToVienLoading = useSelector(selectVienToVienLoading);
  const manufactureProductLoading = useSelector(selectManufactureProductLoading);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [actualSteps, setActualSteps] = useState([]);
  const [stepSlug, setStepSlug] = useState(null);
  const [extraModel, setExtraModel] = useState(null);
  const [cryoModel, setCryoModel] = useState(false)
  const [infusionModal,setInfusionModal] = useState(false);
  const [markModel, setMarkModel] = useState(false);
  const [startModel, setStartModel] = useState(false);
  const [open, setOpen] = useState(false);
  const currentCycle = useSelector(selectCurrentCycle);
  const [publishModal, setPublishModal] = useState(false)
  const [tabCycleChange, setTabCycleChange] = useState(false)
  const [dialogTitle, setDialogTitle] = useState("Marked as Shipped");
  const { bmr_permissions,role_slug } = useSelector((state) => state.loginData);
  const authorizedPerson = ['editor','project-manager']?.includes(role_slug)
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setTabCycleChange(true)
    const index = Number(newValue); // ensure number
    dispatch(changeV2VCycle({ index, cycle: V2VCycle }));
  };
  useEffect(() => {
    setActualSteps(maintainSteps(steps, bmr_permissions, authorizedPerson, buttonPop,role_slug,currentCycle));
  }, [steps, bmr_permissions, authorizedPerson, activeV2VCycle,currentCycle,role_slug]);
/*
    useEffect(() => {
    if (V2VCycle && V2VCycle?.length > 0 && activeV2VCycle > V2VCycle?.length - 1)
      dispatch(changeV2VCycle({ index: 0, cycle: V2VCycle }))
  }, [V2VCycle])
*/
  
 useEffect(() => {
  if (!V2VCycle?.length) return;
  
  if (batchU?.trim() && !tabCycleChange) {
    const index = V2VCycle?.findIndex(it => it?.batch_no == batchU);
    if (index !== -1) {
      dispatch(changeV2VCycle({ index, cycle: V2VCycle }));
      return;
    }
  }
  
    if (V2VCycle && V2VCycle?.length > 0 && activeV2VCycle > V2VCycle?.length - 1){
    dispatch(changeV2VCycle({ index: 0, cycle: V2VCycle }));
  }
}, [V2VCycle, batchU, activeV2VCycle, dispatch]);

  const StepIconComponent = ({ completed }) => (
    <StepIconWrapper completed={completed}>
      {completed && <InnerCircle completed />}
    </StepIconWrapper>
  );

  const handleSubmit = () => {
    onUpdate();
    setOpen(false);
  };

  const defaultOpen=(action,step)=>{
           setOpen(true);
          setStepSlug(step.slug);
          setDialogTitle(action.title);
  }
const handleStepActionClick = (action, step) => {
  switch (action.type) {
    case "dialog":
      switch (true) {
        case action.extra:
          setExtraModel(true);
          defaultOpen(action,step);
          break;

        case action.start:
          setStartModel(true);
          defaultOpen(action,step);
          break;

        case action.cryo:
          setCryoModel(true);
          defaultOpen(action,step);
          break;

        case action.marks:
          setMarkModel(true);
          defaultOpen(action,step);
          break;
          

        case action.infusion:
          setInfusionModal(true);
           defaultOpen(action,step);
          break;

        case action.finishProduct:
          onDirectPrint?.(true);
          break;

        case action.print:
          setPublishModal(true);
          break;

        default:
          setOpen(true);
          setStepSlug(step.slug);
          setDialogTitle(action.title);
      }
      break;

    case "action":
      onAction?.(step);
      break;

    default:
      break;
  }
};

  return (
    <Box sx={{ width: '100%', typography: 'body1' }} className="bg-white rounded-xl">
      <TabContext value={String(activeV2VCycle)}>
        <Box
        >
          <Box className="bg-[#E8EFFC]">
            <TabList
              value={String(activeV2VCycle)}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              onChange={handleChange}
              sx={{ marginBottom: "-1px" }}
              TabIndicatorProps={{ style: { display: "none" } }} // remove default underline
            >
              {V2VCycle?.map((tab, index) => (
                <Tab
                  key={tab?.cycle}
                  value={String(index)}
                  label={
                    <div className="flex items-center gap-2">
                      <span
                        className={`flex gap-2 ${activeV2VCycle === index
                          ? "text-blue-600 font-semibold"
                          : "text-black"
                          }`}
                      > 
                       {tab?.type == 1 ? <FreshIcon color={activeV2VCycle === index ? "#3571FF":"#000"} />:tab?.type == 3 ? <PoolIcon color={activeV2VCycle === index ? "#3571FF":"#000"} />: <Cryopreserve color={activeV2VCycle === index ? "#3571FF":"#000"} />} {tab.cycle}
                      </span>
                      <Chip color={tab.status == 0 || tab.status == 2 ? "error" : "success"} className={`${CycleStatusColor[tab.status]}`} label={CycleStatus[tab?.status]} />
                    </div>
                  }
                  style={activeV2VCycle === index ? {
                    borderTop: "#3571FF solid 1px",
                    borderRight: "#3571FF solid 1px",
                    borderLeft: "#3571FF solid 1px",
                    backgroundColor: "white"
                  } : { border: "transparent" }}
                  className={`normal-case px-4 py-2 rounded-t-lg transition`}
                />
              ))}
            </TabList>
          </Box>
        </Box>
        {V2VCycle?.map((tabData, index) => (
          <TabPanel key={tabData?.cycle} value={String(index)} sx={{ borderTop: "1px solid rgb(53, 113, 255)" }}>
             <ReferenceSection  
               onUpdate={onUpdate}  
               key={'_refrence_'+index} 
               subject_id={formProps?.subject_id} 
                onDirectPrint={onDirectPrint} 
             />
            <Card className="shadow-none bg-[#FAFAFA] border-2">
              <CardContent className="pr-0 relative">
                <Tooltip
                  title="History"
                >
                  <div
                    className="absolute right-3 top-1 cursor-pointer z-[1]"

                    onClick={() => setHistoryOpen(true)}
                  >
                    <HistoryIcon />
                  </div>
                </Tooltip>
                <Stepper alternativeLabel connector={<BarConnector />}>
                  {actualSteps?.map((step, key) => (
                    <Step key={key} completed={step.status === 2}>
                      <Tooltip
                        componentsProps={{
                          tooltip: {
                            sx: {
                              padding: 0,
                              minWidth: 250,
                              borderRadius: "0.95rem",
                              bgcolor: "white",
                              color: "text.primary",
                              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                              position: "relative",
                            },
                            className: "custom-tooltip",
                          },
                          arrow: {
                            sx: {
                              color: "white",
                              "&:before": {
                                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                              },
                            },
                          },
                        }}
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -8], // Adjust vertical offset as needed
                                },
                              },
                            ],
                          },
                        }}
                        placement="top"
                        title={RenderTooltipContent(step?.stepsDetails, step?.name)}
                        arrow
                        disableHoverListener={!step.stepsDetails?.status}
                      >
                        <StepLabel
                          StepIconComponent={StepIconComponent}
                          className={`items-start ${step.stepsDetails ? " cursor-pointer" : ""
                            }`}
                          slotProps={{
                            label: {
                              sx: { marginTop: "10px!important" },
                            },
                          }}
                        >
                          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <div className="flex flex-col items-start">
                              <div className="text-[10px] sm:text-[11px] text-[#ABB7C2] text-left">{`STEP ${key + 1
                                }`}</div>
                              <div className="text-[10px] sm:text-[13px] text-[#0D0B26] text-left break-words">
                                {step.name}
                              </div>
                              <div className="text-[10px] sm:text-[11px] text-[#ABB7C2] text-left flex-col flex">
                                {(step.expected_date || step.started_date) && <span>Expected: {dateFormater(step.expected_date || step.started_date)}</span>}
                                
                                    {step.infusion_date &&
                                  (<div className="block text-orange-600"><span className="text-orange-600">Infusion Date: </span><span>{dateFormater(step.infusion_date)}</span></div>)}
                {!step.tracking_link && step?.awb && <Tooltip
                  title={step?.awb}
                ><span>{truncateText(step?.awb,12)}</span></Tooltip>}
                               
                                {step?.tracking_link && step?.awb && (
                                  <a
                                    href={step?.tracking_link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-[blue] underline"
                                  >
                                  {step?.awb && <Tooltip
                  title={step?.awb}
                ><span>{truncateText(step?.awb,12)}</span></Tooltip>}
                                  </a>
                                )}
                              </div>
                              <div
                                className={`text-[10px] sm:text-[11px] text-left ${StepStatusColor[step.status]
                                  }`}
                              >
                                {StepStatus[step.status]}
                              </div>
                              {step.trackingID && (
                                <div className="text-[10px] sm:text-[11px] text-left">
                                  {step.trackingID}
                                </div>
                              )}

                              {step.actions?.map((action, i) => (
                                <LoadingButton
                                  key={i}
                                  loading={vienToVienLoading || manufactureProductLoading}
                                  variant="contained"
                                  size="small"
                                  className={`mt-2 sm:mt-0 text-[9.5px] w-full sm:w-auto 
                              ${action.color === "error" ? "bg-red-600 hover:bg-red-700" : ""}
                              ${action.color === "success" ? "bg-green-600 hover:bg-green-700" : ""}
                              ${action.color === "primary" ? "bg-blue-600 hover:bg-blue-700" : ""}
                               ${action.color === "warning" ? "bg-yellow-400 hover:bg-yellow-500" : ""}
                              transform transition-all duration-300 hover:-translate-y-1 hover:shadow-lg
                            `}
                                  onClick={() => handleStepActionClick(action,step)}
                                >
                                  {action.title}
                                </LoadingButton>

                              ))}
                            <span className="text-success">   {(step.completed_date &&
                                  dateFormater(step.completed_date)) }
                                </span>
                            </div>
                          </div>
                        </StepLabel>
                      </Tooltip>
                    </Step>
                  ))}
                </Stepper>
              </CardContent>
              <HistoryDrawer
                open={historyOpen}
                onClose={() => setHistoryOpen(false)}
                patient_id={patient_id}
              />
              <BsModal
                fullWidth={true}
                open={open}
                size ={startModel ? 'sm':cryoModel ? 'md':"xs"}
                onClose={() => {setOpen(false); setCryoModel(false);setStartModel(false)}}
                title={dialogTitle}
              >
                {FormComponent && !markModel && !extraModel && !startModel && !infusionModal && !cryoModel && !publishModal && (
                  <FormComponent
                    handleFormSubmit={handleSubmit}
                    setOpen={setOpen}
                    feasibility_id={id}
                    stepSlug={stepSlug}
                    {...formProps}
                  />
                )}
                {extraModel && <RestartManufacturingForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                 {startModel && <StartManufacturingForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {markModel && <MarkAsCompleteForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {infusionModal && <InfusionDateForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  type={markModel ? 'mark': 'infusion'}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}
                
                {cryoModel && <CryoLsmFormDialog  id={formProps?.subject_id} setOpen={setOpen} formProps={formProps} getTimeLine={handleSubmit}/>}
              </BsModal>
            </Card>
                {publishModal && <BatchReleaseCertificate
                        open={publishModal}
                        onClose={() => {
                          setPublishModal(false);
                        }}
                      />}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default ProgressTracker;
